<template>
  <div class="article">
    <van-nav-bar :title="detail.post_title" fixed left-text="返回" left-arrow @click-left="onClickLeft" />
    <div style="height:40px;"></div>
    <div v-html="detail.post_content" class="content"></div>
    <div style="height:120px;"></div>
    <DPtabbar active="0"></DPtabbar>
  </div>
</template>
<script>
import DPtabbar from "@/components/TabBar.vue";
export default {
  name: "detail",
  components: {
    DPtabbar
  },
  data() {
    return {
      detail: {post_title:'标题',post_content:''},
      id: this.$route.params.id
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getData() {
      this.$http
        .get(
          this.GLOBAL.API + "portal/portal/portal_post_detail?post_id=" + this.id,
          {
            params: {},
            headers: { "XX-Device-Type": "mobile" }
          }
        )
        .then(
          response => {
            let data = response.body;
            if (data.code == 1) {
              this.detail = data.data;
              this.detail.post_content = this.detail.post_content.replace(
                /src="default/g,
                'src="' + this.GLOBAL.URL + "upload/default"
              );
            } else {
              this.$toast(data.msg);
            }
          }
        );
    }
  },
  mounted() {
    this.getData();
  }
};
</script>
<style lang="scss" scoped>
.article {
  background-color: #fff;
  .title {
    font-size: 1.6rem;
  }
  .content {
    font-size: 1.4rem;
    padding: 2rem 1rem 1rem 1rem;
    text-align: left;
    margin-bottom: 7rem;
  }
}
</style>